function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "evenodd",
  transform: "matrix(1, 0, 0, 1, 11.028318, 52.080006)"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  transform: "matrix(1, 0, 0, 1, -28.416763, -65.633507)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.945 13.87a1 1 0 0 0-1.415-.045l-7.825 7.345a1 1 0 0 0 0 1.46l7.825 7.345a1.001 1.001 0 1 0 1.37-1.46L19.85 21.9l7.05-6.615a1 1 0 0 0 .045-1.415z"
})));
const SvgArrow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9.828 16.693",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow.3b8ed148.svg";
export { ForwardRef as ReactComponent };